// MainLayout.js

import React from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";

// Pages render inside <main>; they no longer declare their own horizontal
// padding — use <Container> for that.
const MainLayout = ({ children }) => {
  return (
    <div className="flex min-h-screen flex-col bg-bg">
      <Navbar />
      <main className="flex-1">{children}</main>
      <Footer />
    </div>
  );
};

export default MainLayout;
